import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { warmupPageForPath } from './pages/registry'
import './index.css'

const root = document.getElementById('root')!

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

if (root.children.length > 0) {
  // Le module de la route courante est résolu AVANT d'hydrater : sinon le
  // `lazy()` suspendrait pendant l'hydratation et React remplacerait le HTML
  // prérendu par le fallback — contenu perdu et LCP dégradé.
  // Les autres pages restent chargées à la demande, à la navigation.
  warmupPageForPath(window.location.pathname).then(() => {
    ReactDOM.hydrateRoot(root, tree)
  })
} else {
  ReactDOM.createRoot(root).render(tree)
}
